/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LiveSource } from './LiveSource';
import {
    LiveSourceFromJSON,
    LiveSourceFromJSONTyped,
    LiveSourceToJSON,
    LiveSourceToJSONTyped,
} from './LiveSource';
import type { StreamingPlatform } from './StreamingPlatform';
import {
    StreamingPlatformFromJSON,
    StreamingPlatformFromJSONTyped,
    StreamingPlatformToJSON,
    StreamingPlatformToJSONTyped,
} from './StreamingPlatform';
import type { LiveState } from './LiveState';
import {
    LiveStateFromJSON,
    LiveStateFromJSONTyped,
    LiveStateToJSON,
    LiveStateToJSONTyped,
} from './LiveState';
import type { FeaturedStreamSource } from './FeaturedStreamSource';
import {
    FeaturedStreamSourceFromJSON,
    FeaturedStreamSourceFromJSONTyped,
    FeaturedStreamSourceToJSON,
    FeaturedStreamSourceToJSONTyped,
} from './FeaturedStreamSource';
import type { StreamStatus } from './StreamStatus';
import {
    StreamStatusFromJSON,
    StreamStatusFromJSONTyped,
    StreamStatusToJSON,
    StreamStatusToJSONTyped,
} from './StreamStatus';
import type { PresenceOverride } from './PresenceOverride';
import {
    PresenceOverrideFromJSON,
    PresenceOverrideFromJSONTyped,
    PresenceOverrideToJSON,
    PresenceOverrideToJSONTyped,
} from './PresenceOverride';
import type { EffectiveLiveState } from './EffectiveLiveState';
import {
    EffectiveLiveStateFromJSON,
    EffectiveLiveStateFromJSONTyped,
    EffectiveLiveStateToJSON,
    EffectiveLiveStateToJSONTyped,
} from './EffectiveLiveState';

/**
 * Response shape for FeaturedStream — addedBy is serialized as a string ObjectId, _id is a string, and profileImageUrl is populated.
 * @export
 * @interface FeaturedStreamResponse
 */
export interface FeaturedStreamResponse {
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    _id: string;
    /**
     * The creator's own Drop, when they have one. Source of truth for identity and channels.
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    dropId?: string;
    /**
     * Slug of that Drop, so a roster card can link through without a second fetch.
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    dropSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    label: string;
    /**
     * 
     * @type {StreamingPlatform}
     * @memberof FeaturedStreamResponse
     */
    platform?: StreamingPlatform;
    /**
     * Roster-authored name, winning over the linked Drop's own.
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    overrideName?: string;
    /**
     * Roster-authored image, winning over every poller-written one.
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    overrideImageUrl?: string;
    /**
     * Values for the fields this member's roster declares.
     * @type {{ [key: string]: any; }}
     * @memberof FeaturedStreamResponse
     */
    fieldValues?: { [key: string]: any; };
    /**
     * 
     * @type {FeaturedStreamSource}
     * @memberof FeaturedStreamResponse
     */
    source?: FeaturedStreamSource;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    youtubeChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    youtubeLiveId?: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    addedBy: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    addedAt: number;
    /**
     * 
     * @type {StreamStatus}
     * @memberof FeaturedStreamResponse
     */
    status: StreamStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStreamResponse
     */
    isLive: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    viewerCount: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    streamTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    gameName?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    parentCategory?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedStreamResponse
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    language?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedStreamResponse
     */
    classificationLabels?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStreamResponse
     */
    isMature?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    lastLiveAt?: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStreamResponse
     */
    profileImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    lastCheckedAt?: number;
    /**
     * 
     * @type {LiveState}
     * @memberof FeaturedStreamResponse
     */
    liveState?: LiveState;
    /**
     * 
     * @type {EffectiveLiveState}
     * @memberof FeaturedStreamResponse
     */
    effectiveLiveState?: EffectiveLiveState;
    /**
     * 
     * @type {LiveSource}
     * @memberof FeaturedStreamResponse
     */
    liveSource?: LiveSource;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    lastStatusObservedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    lastMetadataObservedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStreamResponse
     */
    lastOfflineAt?: number;
    /**
     * 
     * @type {PresenceOverride}
     * @memberof FeaturedStreamResponse
     */
    presenceOverride?: PresenceOverride;
    /**
     * Whether this member currently counts on the roster. "On the team but paused", distinct from live state and from removal.
     * @type {boolean}
     * @memberof FeaturedStreamResponse
     */
    enabled?: boolean;
    /**
     * Always surface this member regardless of the roster's live filter.
     * @type {boolean}
     * @memberof FeaturedStreamResponse
     */
    exemptFromGameFilter?: boolean;
    /**
     * Drop ids this member is official for. Empty means the whole franchise.
     * @type {Array<string>}
     * @memberof FeaturedStreamResponse
     */
    scopeDropIds?: Array<string>;
}



/**
 * Check if a given object implements the FeaturedStreamResponse interface.
 */
export function instanceOfFeaturedStreamResponse(value: object): value is FeaturedStreamResponse {
    if (!('_id' in value) || value['_id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('addedBy' in value) || value['addedBy'] === undefined) return false;
    if (!('addedAt' in value) || value['addedAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isLive' in value) || value['isLive'] === undefined) return false;
    if (!('viewerCount' in value) || value['viewerCount'] === undefined) return false;
    return true;
}

export function FeaturedStreamResponseFromJSON(json: any): FeaturedStreamResponse {
    return FeaturedStreamResponseFromJSONTyped(json, false);
}

export function FeaturedStreamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeaturedStreamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'],
        'dropId': json['dropId'] == null ? undefined : json['dropId'],
        'dropSlug': json['dropSlug'] == null ? undefined : json['dropSlug'],
        'label': json['label'],
        'platform': json['platform'] == null ? undefined : StreamingPlatformFromJSON(json['platform']),
        'overrideName': json['overrideName'] == null ? undefined : json['overrideName'],
        'overrideImageUrl': json['overrideImageUrl'] == null ? undefined : json['overrideImageUrl'],
        'fieldValues': json['fieldValues'] == null ? undefined : json['fieldValues'],
        'source': json['source'] == null ? undefined : FeaturedStreamSourceFromJSON(json['source']),
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'youtubeLiveId': json['youtubeLiveId'] == null ? undefined : json['youtubeLiveId'],
        'priority': json['priority'],
        'addedBy': json['addedBy'],
        'addedAt': json['addedAt'],
        'status': StreamStatusFromJSON(json['status']),
        'isLive': json['isLive'],
        'viewerCount': json['viewerCount'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'parentCategory': json['parentCategory'] == null ? undefined : json['parentCategory'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'language': json['language'] == null ? undefined : json['language'],
        'classificationLabels': json['classificationLabels'] == null ? undefined : json['classificationLabels'],
        'isMature': json['isMature'] == null ? undefined : json['isMature'],
        'lastLiveAt': json['lastLiveAt'] == null ? undefined : json['lastLiveAt'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'lastCheckedAt': json['lastCheckedAt'] == null ? undefined : json['lastCheckedAt'],
        'liveState': json['liveState'] == null ? undefined : LiveStateFromJSON(json['liveState']),
        'effectiveLiveState': json['effectiveLiveState'] == null ? undefined : EffectiveLiveStateFromJSON(json['effectiveLiveState']),
        'liveSource': json['liveSource'] == null ? undefined : LiveSourceFromJSON(json['liveSource']),
        'lastStatusObservedAt': json['lastStatusObservedAt'] == null ? undefined : json['lastStatusObservedAt'],
        'lastMetadataObservedAt': json['lastMetadataObservedAt'] == null ? undefined : json['lastMetadataObservedAt'],
        'lastOfflineAt': json['lastOfflineAt'] == null ? undefined : json['lastOfflineAt'],
        'presenceOverride': json['presenceOverride'] == null ? undefined : PresenceOverrideFromJSON(json['presenceOverride']),
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'exemptFromGameFilter': json['exemptFromGameFilter'] == null ? undefined : json['exemptFromGameFilter'],
        'scopeDropIds': json['scopeDropIds'] == null ? undefined : json['scopeDropIds'],
    };
}

export function FeaturedStreamResponseToJSON(json: any): FeaturedStreamResponse {
    return FeaturedStreamResponseToJSONTyped(json, false);
}

export function FeaturedStreamResponseToJSONTyped(value?: FeaturedStreamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'dropId': value['dropId'],
        'dropSlug': value['dropSlug'],
        'label': value['label'],
        'platform': StreamingPlatformToJSON(value['platform']),
        'overrideName': value['overrideName'],
        'overrideImageUrl': value['overrideImageUrl'],
        'fieldValues': value['fieldValues'],
        'source': FeaturedStreamSourceToJSON(value['source']),
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'youtubeLiveId': value['youtubeLiveId'],
        'priority': value['priority'],
        'addedBy': value['addedBy'],
        'addedAt': value['addedAt'],
        'status': StreamStatusToJSON(value['status']),
        'isLive': value['isLive'],
        'viewerCount': value['viewerCount'],
        'thumbnailUrl': value['thumbnailUrl'],
        'streamTitle': value['streamTitle'],
        'gameName': value['gameName'],
        'gameId': value['gameId'],
        'parentCategory': value['parentCategory'],
        'tags': value['tags'],
        'language': value['language'],
        'classificationLabels': value['classificationLabels'],
        'isMature': value['isMature'],
        'lastLiveAt': value['lastLiveAt'],
        'profileImageUrl': value['profileImageUrl'],
        'lastCheckedAt': value['lastCheckedAt'],
        'liveState': LiveStateToJSON(value['liveState']),
        'effectiveLiveState': EffectiveLiveStateToJSON(value['effectiveLiveState']),
        'liveSource': LiveSourceToJSON(value['liveSource']),
        'lastStatusObservedAt': value['lastStatusObservedAt'],
        'lastMetadataObservedAt': value['lastMetadataObservedAt'],
        'lastOfflineAt': value['lastOfflineAt'],
        'presenceOverride': PresenceOverrideToJSON(value['presenceOverride']),
        'enabled': value['enabled'],
        'exemptFromGameFilter': value['exemptFromGameFilter'],
        'scopeDropIds': value['scopeDropIds'],
    };
}

